var Filters = function () {

	this.init = function () {

		this.filter();
	}

	this.filter = function () {

		$(window).on('load', function () {
			if ($(':checkbox:checked')) {
				$(':checkbox:checked').prop('checked', false);
			}
		});

		$("body").on("click", '.btn-filter', function (e) {
			e.preventDefault();

			$('.filters-content').slideToggle();
		});
	}

	return this.init();

}
